export default class BatchMessageGroupDetailModel {
	public preSubmissionConfigurationId: string;
	public groupDetails: GroupDetail[];
	public partitionKey: string;

	constructor() {
		this.preSubmissionConfigurationId = "";
		this.groupDetails = [];
		this.partitionKey = "";
	}
}

export type DynamicVariableDetail = { key: string; value: string };

export type PhoneNumberDynamicVariablesDetail = {
	phoneNumber: string;
	variables: DynamicVariableDetail[];
};

export class GroupDetail {
	public id: string | null;
	public name: string;
	public phoneNumbers: PhoneNumberDynamicVariablesDetail[];
	public phoneNumberListURL: string;
	public phoneNumberCount: number;

	constructor() {
		this.id = null;
		this.name = "";
		this.phoneNumbers = [];
		this.phoneNumberListURL = "";
		this.phoneNumberCount = 0;
	}
}
